module.exports = __webpack_public_path__ + "img/logo1.4c9bfa5a.png";